import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./CandidatesBlock.scss";
import useTranslationCandidates from "../useTranslationCandidates";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import CandidateSearchBox from "../search/CandidateSearchBox";
import CandidatesWithApplicationCountList from "./CandidatesWithApplicationCountList";
import ActionButton from "../../common/widgets/ActionButton";
import * as ROUTES from "../../../constants/routes";
import { useHistory } from "react-router-dom";
import RouterUtils from "../../../utils/RouterUtils";

export default function CandidatesBlock(props) {
  const { recruiterId } = props;
  const { t, loading: tLoading } = useTranslationCandidates();
  useShowLoader(tLoading);

  const history = useHistory();

  const onClickCreateCandidate = (event) => {
    event.preventDefault();
    history.push(ROUTES.RECRUITER_CANDIDATE_CREATE);
  };

  const onSelectOption = (option) =>
    history.push(
      RouterUtils.injectParamsInRoute(ROUTES.RECRUITER_CANDIDATE_PROFILE, {
        candidateId: option._id,
      })
    );

  return (
    <div className="CandidatesBlock">
      <Row>
        <Col className="page-title">
          <h1>{t("candidates:candidates_page_title")}</h1>
        </Col>
        <Col className={"button-col"}>
          <ActionButton onClick={onClickCreateCandidate}>
            {t("candidates:candidates_dashboard_create_candidate_button_label")}
          </ActionButton>
        </Col>
      </Row>
      <Row className={"search-block-row"}>
        <Col>
          <CandidateSearchBox
            autofocus
            recruiterId={recruiterId}
            onSelectOption={onSelectOption}
          />
        </Col>
      </Row>
      <Row>
        <Col className="widget-block">
          <Row>
            <Col>
              <CandidatesWithApplicationCountList recruiterId={recruiterId} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
